import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import moment from "moment";

import WP from "WP";

import { capitalize } from "helpers";

import GridElement from "partials/GridElement";
import Tooltip from "partials/Tooltip";
import SmartLink from "partials/SmartLink";
import Trash from "icons/TrashIcon";

class CartSummary extends Component {
  removeRoom(reservationIndex) {
    this.props.removeReservationFunc(reservationIndex);
  }

  getDateRange = () => {
    let from = new Date(this.props.availability.fromDate);
    let to = new Date(this.props.availability.toDate);
    console.log(from, to);

    return (
      capitalize(moment(from.toUTCString()).format("ddd")) +
      " " +
      moment(from.toUTCString()).format("D.") +
      " – " +
      capitalize(moment(to.toUTCString()).format("ddd")) +
      " " +
      capitalize(moment(to.toUTCString()).format("D. MMM. YYYY"))
    );
  };

  render() {
    const { reservations } = this.props;

    const hotels = [];
    let price = 0;

    reservations.forEach((reservation, reservationIndex) => {
      let existingHotelIndex = hotels.findIndex(
        (hotel) => hotel.name === reservation.hotelName
      );

      reservation.reservationIndex = reservationIndex;

      if (existingHotelIndex === -1) {
        hotels.push({
          name: reservation.hotelName,
          rooms: [reservation],
        });
      }
      if (existingHotelIndex !== -1) {
        hotels[existingHotelIndex].rooms.push(reservation);
      }

      price += reservation.room.availability.prices[0].calculatedPrice;
    });

    return (
      <WrapperGridElement
        colStart={{ default: 1, s: 13, l: 17 }}
        colEnd={{ default: 8, s: 24, l: 22 }}
        rowStart={{ default: 2, s: 1 }}
        rowEnd={{ default: 3, s: 10 }}
        rowSpan
      >
        <ContentWrapper>
          <StyledToolTip
            idx={1}
            active={1}
            data={WP.trans.reservationExpireNotice}
          />
          {hotels.map((hotel, i) => {
            return (
              <React.Fragment key={i}>
                <Name>{hotel.name}</Name>
                <DateRange>{this.getDateRange()}</DateRange>
                <OrderWrapper>
                  {hotel.rooms &&
                    hotel.rooms.map((room, i) => {
                      return (
                        <OrderLine key={i}>
                          <div>
                            <Content>{room.room.room_name}</Content>
                            <Content>
                              NOK{" "}
                              {room.room.availability.prices[0].calculatedPrice}
                            </Content>
                          </div>
                          <StyledRemoveRoom
                            onClick={() =>
                              this.removeRoom(room.reservationIndex)
                            }
                          >
                            <Trash />
                          </StyledRemoveRoom>
                        </OrderLine>
                      );
                    })}
                </OrderWrapper>
              </React.Fragment>
            );
          })}
          <SmartLink
            to={WP && WP.lang === "en" ? "/en/accommodation" : "/overnatting"}
          >
            {WP.trans.addMoreRooms}
          </SmartLink>
        </ContentWrapper>
        <PriceSummary>{WP.trans.totalNok + " " + price}</PriceSummary>
      </WrapperGridElement>
    );
  }
}

const mapStateToProps = (state) => ({
  availability: state.availability,
});

export default connect(mapStateToProps, null)(CartSummary);

const WrapperGridElement = styled(GridElement)`
  position: relative;
  align-self: start;
  width: 100%;
  background-color: ${(props) => props.theme.colors.bg};
  color: ${(props) => props.theme.colors.text};
  padding: 0 !important;
  margin-bottom: ${(props) => props.theme.spacing.elementXL};
`;

const ContentWrapper = styled.div`
  padding: ${(props) => props.theme.spacing.contentXL}
    ${(props) => props.theme.spacing.elementXS}
    ${(props) => props.theme.spacing.elementS};

  span {
    text-decoration: none !important;
    color: ${(props) => props.theme.colors.text}!important;
    cursor: default !important;
  }

  a {
    font-size: 14px;
    line-height: 25px;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.text}!important;
  }
`;

const Name = styled.span`
  ${(props) => props.theme.fonts.h4};
  display: block;
  line-height: 38px;
  margin-bottom: ${(props) => props.theme.spacing.contentM};
  padding: 0 !important;
`;

const Content = styled.span`
  display: block;
  font-size: 14px;
  line-height: 25px;
`;

const DateRange = styled(Content)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};
`;

const OrderWrapper = styled.div`
  padding-bottom: ${(props) => props.theme.spacing.contentM};
`;

const OrderLine = styled.div`
  padding-bottom: ${(props) => props.theme.spacing.contentL};
  display: flex;

  div {
    margin-right: 56px;
  }

  svg {
    margin-top: 5px;
    align-self: flex-start;
    cursor: pointer;
  }
`;

const StyledRemoveRoom = styled.div``;

const StyledToolTip = styled(Tooltip)`
  position: relative;
  transform: translateX(0);
  grid-column: 1 / 12;
  padding: 15px;
  min-width: 100%;
  margin-top: 15px;

  &::after {
    visibility: hidden;
  }
`;

const PriceSummary = styled.div`
  transition: opacity 0.2s ease;
  font-family: "Untitled", serif;
  font-weight: normal;
  background: ${(props) => props.theme.colors.button};
  color: ${(props) => props.theme.colors.negative};
  width: 100%;
  font-size: 16px;
  text-align: center;
  padding: ${(props) => props.theme.spacing.contentS}
    ${(props) => props.theme.spacing.contentXS};
`;
